"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRolesWithAllAccountAccess = void 0;
const api_models_1 = require("@portal/api-models");
exports.UserRolesWithAllAccountAccess = new Set([
    api_models_1.FlatRole.InternalManager,
    api_models_1.FlatRole.InternalViewer,
]);
